<template>
    <div class="options">
        <div class="option" v-for="(option, index) in options" :key="index">
            <!-- Passing in the whole object on *value* so I can access different properties on parent component -->
            <input
                class="radio"
                type="radio"
                v-model="selectedOption"
                :name="option[valueKey]"
                :id="_uid + '' + index"
                :value="option[idKey]"
                @change="setChoice"
            />
            <label :for="_uid + '' + index">
                <div class="option__color-container">
                    <div class="option__colour" :style="'background-color: ' + option.primary_hex"/>
                    <div class="option__name">{{ option.name }}</div>
                </div>

                <span class="option-price">+ £{{ option[priceKey] }}</span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            default: null
        },
        idKey: {
            required: true
        },
        valueKey: {
            required: true
        },
        priceKey: {
            default: null,
            required: false
        },
        options: {
            type: [Array, Object],
            required: true
        },
    },
    watch: {
        value(newValue) {
            this.selectedOption = newValue;
        }
    },
    data() {
        return {
            selectedOption: this.value,
        }
    },
    methods: {
        setChoice: function () {
            this.$emit('input', this.selectedOption)
        },
    }
}
</script>

<style lang="scss" scoped>
.options {
    @media (max-width: 767px) {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
    }

    @media (min-width: 768px) and (max-width: 991px) {
        display: grid;
        grid-auto-flow: column;
        column-gap: 30px;
        overflow-x: auto;
        padding: 0 0 15px 0;
    }

    @media (min-width: 992px) {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
    }

    label {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        justify-content: space-between;
        color: #0093D6;
        font-size: 16px;
        font-weight: 600;

        @media (min-width: 768px) and (max-width: 991px) {
            height: 100%;
        }
    }
}

.option {
    width: 100%;
    height: 100%;

    @media (min-width: 768px) and (max-width: 991px) {
        min-width: 250px;
    }

    &__colour {
        border-radius: 20px;
        width: 20px;
        height: 20px;
        display: inline-block;
        margin-right: 15px;
        flex-shrink: 0;
    }

    &__name {
        flex-shrink: 1;
    }

    &__color-container {
        display: flex;
        flex-shrink: 1;
        align-items: center;
    }

    &__price {
        flex-shrink: 0;
    }
}

.radio {
    display: none;
}

.radio + label {
    width: 100%;
    padding: 13px 10px;
    border-radius: 6px;
    border: 1px solid #0093D6;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
        background-color: #0093D6;
        color: #FFF;
    }
}

.radio:checked + label {
    background-color: #0093D6;
    color: #FFF;
}
</style>